module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Missed-call-b67f59d3862b0aa2a6cac30b17528fde.svg";